import variables from '../../styles/variables.module.scss';
// import caseImg from '../../assets/frames/drumster-caseimg-min.webp';
// import caseImgAlt from '../../assets/frames/drumster-caseimg-min.png';
import caseimg from '../../assets/cases/drumster-caseimg.jpg';

export default {
  key: 'drumster',
  path: '/cases/drumster',
  color: variables.drumster,
  case: { fall: caseimg },
  title: 'Drumster',
  description: 'Smart cable drum recycling',
  headline: 'iOS & Android application',
  isWeb: false,
  isAndroid: false,
  textColor: variables.carbonBlack,
};
